import {
    FETCH_INOVICE_MONTHS_REQUEST,
    FETCH_INOVICE_MONTHS_SUCCESS,
    FETCH_INOVICE_MONTHS_FAILED,
    FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST,
    FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS,
    FETCH_INVOICE_ANNUAL_SUMMARY_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED,
    FETCH_SELECTED_YEAR,
    FETCH_BULK_LATEST_MONTH_REQUEST,
    FETCH_BULK_LATEST_MONTH_SUCCESS,
    FETCH_BULK_LATEST_MONTH_FAILED,
    REQUEST_BULK_DOWNLOAD_REQUEST,
    REQUEST_BULK_DOWNLOAD_SUCCESS,
    REQUEST_BULK_DOWNLOAD_FAILED,
    FETCH_BULK_JOBS_REQUEST,
    FETCH_BULK_JOBS_SUCCESS,
    FETCH_BULK_JOBS_FAILED,
    UPDATE_BULK_JOB
} from './mutation-type'

const mutations = {
    [FETCH_INOVICE_MONTHS_REQUEST]: state => {
        state.status.months = 'loading'
    },
    [FETCH_INOVICE_MONTHS_SUCCESS]: (state, { status, data }) => {
        state.status.months = status
        if (status === 204) {
            state.months = []
            state.summary = []
        } else {
            state.months = data
        }
    },
    [FETCH_INOVICE_MONTHS_FAILED]: (state, error) => {
        state.status.months = 'error'
    },
    [FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST]: state => {
        state.status.summary = 'loading'
    },
    [FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS]: (state, { status, data }) => {
        state.status.summary = status
        if (status === 204) {
            state.summary = []
        } else {
            state.summary = data
        }
    },
    [FETCH_INVOICE_ANNUAL_SUMMARY_FAILED]: (state, error) => {
        state.status.summary = 'error'
    },
    [DOWNLOAD_INVOICE_PDF_REQUEST]: state => {
        state.status.pdfDownload = 'loading'
    },
    [DOWNLOAD_INVOICE_PDF_SUCCESS]: (state, data) => {
        state.status.pdfDownload = 'success'
    },
    [DOWNLOAD_INVOICE_PDF_FAILED]: (state, error) => {
        state.status.pdfDownload = 'error'
    },
    [FETCH_SELECTED_YEAR]: (state, data) => {
        state.selectedYear = data
    },
    [FETCH_BULK_LATEST_MONTH_REQUEST]: state => {
        state.status.bulkLatestMonth = 'loading'
    },
    [FETCH_BULK_LATEST_MONTH_SUCCESS]: (state, info) => {
        state.status.bulkLatestMonth = 'success'
        state.bulkLatestMonth = info.latestMonth
        state.bulkRequestInfo = {
            mailAttachLimitBytes: info.mailAttachLimitBytes,
            expireDays: info.expireDays
        }
    },
    [FETCH_BULK_LATEST_MONTH_FAILED]: state => {
        state.status.bulkLatestMonth = 'error'
        state.bulkLatestMonth = null
        state.bulkRequestInfo = {
            mailAttachLimitBytes: null,
            expireDays: null
        }
    },
    [REQUEST_BULK_DOWNLOAD_REQUEST]: state => {
        state.status.bulkRequest = 'loading'
    },
    [REQUEST_BULK_DOWNLOAD_SUCCESS]: state => {
        state.status.bulkRequest = 'success'
    },
    [REQUEST_BULK_DOWNLOAD_FAILED]: state => {
        state.status.bulkRequest = 'error'
    },
    [FETCH_BULK_JOBS_REQUEST]: state => {
        state.status.bulkJobs = 'loading'
    },
    [FETCH_BULK_JOBS_SUCCESS]: (state, jobs) => {
        state.status.bulkJobs = 'success'
        state.bulkJobs = jobs
    },
    [FETCH_BULK_JOBS_FAILED]: state => {
        state.status.bulkJobs = 'error'
    },
    /** 폴링 결과로 해당 건만 교체한다. 목록 전체를 다시 받지 않아 화면 깜빡임이 없다. */
    [UPDATE_BULK_JOB]: (state, job) => {
        const index = state.bulkJobs.findIndex(item => item.jobId === job.jobId)
        if (index === -1) return
        state.bulkJobs.splice(index, 1, job)
    }
}

export default mutations
